module.exports = __webpack_public_path__ + "static/img/ios_ps.0c79c585.png";